<template>
	<el-row>
		<el-row>
			<el-form label-width="140px" label-position="right" style="width: 800px;font-size: 17px;font-weight: bold">
				<el-form-item label="剧本类型:">
					<span v-if="scenarioType == '01'">构建信任</span>
					<span v-if="scenarioType == '02'">拓新吸粉</span>
					<span v-if="scenarioType == '04'">私聊话术</span>
					<span v-if="scenarioType == '03'">产品种草</span>
				</el-form-item>
				<el-form-item label="针对人设:">
					<el-tag v-for="(tag,index) in labelVosName" :key="index">
						{{tag}}
					</el-tag>
				</el-form-item>
				<el-form-item label="推荐人群:">
					<el-tag v-for="(tag,index) in labelVoList3" :key="index">
						{{tag}}
					</el-tag>
				</el-form-item>
				<el-form-item label="针对品类:">
					{{this.$route.query.primaryName}} -- {{this.$route.query.secondaryName}}
				</el-form-item>
			</el-form>
		</el-row>
		<template v-if="infoList.length>0">
			<div v-for="(item,index) in infoList" :key="index">
				<el-form label-width="150px" label-position="right" style="background-color: #f2f2f2;">
					<el-form-item label="剧本天数:">
						<span>第{{item.dayNumber}}天</span>
						<!-- <el-input v-model="item.dayNumber" type="number" style="width: 80px;"
							:disabled="item.disable" />
						<span></span> -->
					</el-form-item>
					<el-form-item label="策略类型:">
						<el-select v-model="item.tacticsType" :disabled="item.disable">
							<el-option v-for="(item2,index) in options3" :key="index" :value="item2.value"
								:label="item2.label"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="策略描述:">
						<el-input v-model="item.tacticsDescription" style="width: 500px;" :disabled="item.disable">
						</el-input>
					</el-form-item>
					<el-form-item label="目标任务:">
						<el-input v-model="item.targetTask" type="number" style="width: 80px;" :disabled="item.disable">
						</el-input>
						<span v-if="scenarioType == '01' || scenarioType  == '03'">条/天</span>
						<span v-if="scenarioType== '02' || scenarioType == '04'">人/天</span>
					</el-form-item>
					<el-form-item label="目标任务描述:">
						<el-input v-model="item.targetDescription" style="width: 500px;" :disabled="item.disable">
						</el-input>
					</el-form-item>
					<el-form-item label="场景动作:">
						<el-select v-model="item.scenario" :disabled="item.disable">
							<el-option v-for="(item2,index) in options4" :key="index" :value="item2.value"
								:label="item2.label"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="场景动作描述:">
						<el-input v-model="item.sceneDescription" style="width: 500px;" :disabled="item.disable">
						</el-input>
					</el-form-item>
					<el-form-item label="私聊用例:" v-if="scenarioType == '04'">
						<div v-if="item.chatScriptAos.length>0">
							<div style="width: 500px;padding: 15px;display: flex;align-items: center;"
								v-for="(item2,index2) in item.chatScriptAos" :key="index2">
								<div style="border: 1px dotted #83d4f6;">
									<div v-for="(item3,index3) in item2" :key="index3" style="display: flex;">
										<div v-if="item3.chatType == '01'"
											style="display: flex;align-items: center;justify-content: flex-start;width: 400px;">
											<img src="https://xinian.oss-cn-beijing.aliyuncs.com/smallProgram/hunianimg/sx/05.png"
												width="50px" height="50px" />
											<el-input v-model="item3.chatContent" style="width: 350px"
												:disabled="item.disable"></el-input>
											<el-button @click="del4(item2, index,index2,index3)"
												icon="el-icon-delete-solid" type="text" :disabled="item.disable">
											</el-button>
										</div>
										<div v-if="item3.chatType == '02'"
											style="display: flex;align-items: center;justify-content: flex-end;width: 400px;">
											<el-button @click="del4(item3, index,index2,index3)"
												icon="el-icon-delete-solid" type="text" :disabled="item.disable">
											</el-button>
											<el-input v-model="item3.chatContent" style="width: 350px"
												:disabled="item.disable"></el-input>
											<img src="https://xinian.oss-cn-beijing.aliyuncs.com/smallProgram/hunianimg/sx/06.png"
												width="50px" height="50px" />
										</div>
									</div>
									<div style="display: flex;width: 400px;justify-content: space-around;">
										<el-button @click="add(1,index,index2)" type="text" :disabled="item.disable">
											左面加一条</el-button>
										<el-button @click="add(2,index,index2)" type="text" :disabled="item.disable">
											右面加一条</el-button>
									</div>
								</div>
								<div>
									<el-button @click="del2(index,index2)" icon="el-icon-delete"
										:disabled="item.disable">
									</el-button>
								</div>
							</div>
						</div>
						<el-button @click="addCircleIds2(index)" icon="el-icon-plus" :disabled="item.disable">
						</el-button>
					</el-form-item>
					<el-form-item label="活动用例:">
						<template v-if="scenarioType == '01' || scenarioType == '03'">
							<div v-if="item.circleIds.length>0" style="display: flex;flex-wrap: wrap;">
								<div v-for="(item2,index2) in item.circleIds" :key="index2" style="margin-right: 10px;">
									<div
										style="width: 200px;height: 90%;border: 1px dotted #83d4f6;padding: 5px;position: relative;">
										<div style="height: 30%;overflow: hidden;text-overflow: ellipsis;display:-webkit-box;
								-webkit-box-orient:vertical;-webkit-line-clamp:3;">
											{{item2.matInfo}}
										</div>
										<div style="text-align: center;height: 70%;">
											<!-- {{item2.img}} -->
											<video v-if="item2.img.substring(item2.img.length - 3) == 'mp4'"
												:src="item2.img" width="180px" height="100px" controls></video>
											<el-image v-else :src="item2.img" style="width: 100px;height: 100px;">
											</el-image>
										</div>
										<div style="position: absolute;right: 0;bottom: 0px;">
											<el-button type="text" icon="el-icon-delete" @click="del(index2)"
												:disabled="item.disable">
											</el-button>
										</div>
									</div>
								</div>
							</div>
						</template>
						<template v-if="scenarioType == '02' || scenarioType == '04'">
							<template v-if="item.activityCasesAos.length>0">
								<div v-for="(item2,index2) in item.activityCasesAos" :key="index2"
									style="width: 100%;display: flex;flex-wrap: wrap;">
									<div style="display: flex;align-items: center;width: 400px;">
										<el-form label-position="right" label-width="140px"
											style="border: 1px dotted #83d4f6;padding: 15px">
											<el-form-item label="商品id:">
												<el-input v-model="item2.commodityId" size="mini" type="number"
													:disabled="item.disable"></el-input>
											</el-form-item>
											<el-form-item label="活动名称:">
												<el-input v-model="item2.activityName" size="mini"
													:disabled="item.disable" type="textarea" maxlength="50"
													show-word-limit></el-input>
											</el-form-item>
											<el-form-item label="活动/商品图片:">
												<el-upload :action="uploadUrl" list-type="picture-card"
													:on-success="getPictrueURL.bind(null, {'index':index2,'data':item})"
													accept=".jpg,.png" :file-list="item2.commodityPic"
													v-if="item2.commodityPic.length==0">
													<i class="el-icon-plus" />
												</el-upload>
												<div style="display: flex;align-items: center;"
													v-if="item2.commodityPic.length>0">
													<el-image style="width: 150px;height: 150px;"
														:src="item2.commodityPic[0].url"></el-image>
													<div style="margin-left: 20px;">
														<el-button icon="el-icon-delete" size="small"
															@click="delImg(index,index2,item2)" type="primary"
															:disabled="item.disable"></el-button>
													</div>
												</div>
											</el-form-item>
										</el-form>
										<div>
											<el-button icon="el-icon-delete" @click="del(index2)"
												:disabled="item.disable"></el-button>
										</div>
									</div>
								</div>
							</template>
						</template>
						<el-button @click="addCircleIds(index)" icon="el-icon-plus" :disabled="item.disable">
						</el-button>
					</el-form-item>
					<el-form-item v-if="infoList.length>0">
						<el-button @click="editor(index)" v-if="item.cz">
							{{item.disable ? '编辑' : '完成'}}
						</el-button>
						<el-button @click="sumbit" size="medium" v-if="!item.cz">确认</el-button>
						<el-button v-if="item.cz &&(index + 1) - 0 == infoList.length" @click="delInfoList(item,index)"
							size="medium">删除
						</el-button>
					</el-form-item>
				</el-form>
			</div>
		</template>
		<el-button type="primary" @click="addInfoList()" v-if="isShow">创建下一天动作+</el-button>
		<el-dialog :visible.sync="dialogVisible" title="请选择圈文素材" center width="80%" style="height: auto;">
			<el-row>
				<el-col :span="6">
					<span style="margin-right: 10px;">素材分类</span>
					<el-cascader v-model="query.arr" :options="options" :props="props" clearable></el-cascader>
				</el-col>
				<el-col :span="6">
					<span style="margin:0 10px;">圈文类型</span>
					<el-select v-model="query.id2" clearable>
						<el-option v-for="(item2,index) in options5" :key="index" :value="item2.value"
							:label="item2.label">
						</el-option>
					</el-select>
				</el-col>
				<el-col :span="6">
					<span style="margin:0 10px;">针对人设</span>
					<el-select v-model="query.matPersona" clearable>
						<el-option v-for="item in options2" :key="item.id" :value="item.id" :label="item.name">
						</el-option>
					</el-select>
				</el-col>
				<el-col :span="6">
					<el-input v-model="query.title4" style="width: 90%;" placeholder="请输入圈文名称"></el-input>
					<el-button @click="Query">筛选</el-button>
					<el-button @click="zhikong">置空</el-button>
				</el-col>
			</el-row>
			<el-table :data="tableData" style="margin-top: 10px;">
				<el-table-column label="ID" prop="matId"></el-table-column>
				<el-table-column label="圈文">
					<template slot-scope="scope">
						<div style="display: flex;justify-content: center;align-items: center;">
							<div>
								<video v-if="scope.row.matImg2.substring(scope.row.matImg2.length - 3) == 'mp4'"
									:src="scope.row.matImg2" width="100px" height="100px"></video>
								<el-image v-else :src="scope.row.matImg2" style="width: 50px;height: 50px;"></el-image>
							</div>
							<div style="text-align: center;">
								{{scope.row.matInfo }}
							</div>
						</div>
					</template>
				</el-table-column>
				<el-table-column label="下载" prop="downNum"></el-table-column>
				<el-table-column label="操作">
					<template slot-scope="scope">
						<el-button type="text" @click="choose(scope.row)">选用</el-button>
					</template>
				</el-table-column>
			</el-table>
			<div style="margin: 20px auto;width: 500px">
				<el-pagination class="pagination" background layout="total, sizes,prev, pager, next,jumper"
					:page-size="pageSize" :page-sizes="[30,60,100]" :total="total" :current-page.sync="pageNum"
					@size-change="handleSizeChange" @current-change="handleCurrentChange" />
			</div>
		</el-dialog>
	</el-row>
</template>

<script>
	import httpClient from "../../util/request.js"
	export default {
		data() {
			return {
				uploadUrl: httpClient.imgUrl, //上传路径
				isShow: true, //添加下一天按钮是否隐藏
				scenarioType: this.$route.query.scenarioType, //剧本类型
				infoList: [], //明细信息
				dialogVisible: false, //选择作品弹框
				query: {
					arr: [],
					id2: '',
					matPersona: '',
					title4: ''
				}, //查询作品条件
				indexs: 0, //infoList当前几个集合
				tableData: [], //圈文集合
				pageNum: 1,
				pageSize: 30,
				total: 0,
				arr: [], //品类
				options: [], //分类集合
				options2: [], //人设集合
				options3: [], //策略集合
				options4: [], //动作集合
				options5: [], //圈文类型
				props: {
					value: "id",
					label: "name",
					children: "children",
				}, //分类
				props2: {
					value: "id",
					label: "name",
					children: "sonList",
					// multiple: true
				}, //人设
				labelVosName: (this.$route.query.labelVosName).split(','),
				labelVoList3: (this.$route.query.labelVoList3).split(','),
			}
		},
		methods: {
			//删除聊天话术的某一条
			del4(item, index, index2, index3) {
				console.log(index, index2, index3);
				this.infoList[index].chatScriptAos[index2].splice(index3, 1);
			},
			//删除活动商品的图片
			delImg(index, index2, item) {
				this.infoList[index].activityCasesAos[index2].commodityPic = []
			},
			//聊天话术左右
			add(num, index, index2) {
				switch (num) {
					case 1: {
						this.infoList[index].chatScriptAos[index2].push({
							chatType: "01",
							chatContent: "",
						});
						break;
					}
					case 2: {
						this.infoList[index].chatScriptAos[index2].push({
							chatType: "02",
							chatContent: "",
						});
						break;
					}
				}
				console.log(this.infoList[index].chatScriptAos);
			},
			//上传图片成功
			getPictrueURL(obj, res, file, fileList) {
				if (res.status == 1) {
					this.$message.error(res.msg)
					fileList.pop()
				} else {
					var index = obj.index;
					this.infoList[this.indexs].activityCasesAos[index].commodityPic.push({
						url: res.data
					})
					console.log(this.infoList);
				}
			},
			//添加剧本的一天
			sumbit() {
				let info = this.infoList[this.indexs]
				var p = /^(?!(0[0-9]{0,}$))[0-9]{1,}[.]{0,}[0-9]{0,}$/;
				if (info.tacticsType == '' || info.tacticsDescription == '' || info.dayNumber == '' ||
					info.targetDescription == '' || info.scenario == '' || info.sceneDescription == '' ||
					info.targetTask == '') {
					this.$message.error('剧本详情未填写完整')
					return false
				}
				if (!p.test(info.dayNumber)) {
					this.$message({
						type: 'error',
						message: '剧本天数不能为负数和0'
					});
					return false
				}
				if (!p.test(info.targetTask)) {
					this.$message({
						type: 'error',
						message: '目标任务天数不能为负数和0'
					});
					return false
				}
				console.log(info.scenarioType);
				let circleIds = []
				if (info.scenarioType == '01' || info.scenarioType == '03') {
					if (info.circleIds.length > 0) {
						info.circleIds.forEach(i => {
							circleIds.push(i.id)
						})
					} else {
						this.$message.error('活动用例未选择')
						return false
					}
				}
				let chatScriptMap = {}
				if (info.scenarioType == '04') {
					if (info.chatScriptAos.length > 0) {
						for (var i = 0; i < info.chatScriptAos.length; i++) {
							if (info.chatScriptAos[i].length > 0) {
								for (var q = 0; q < info.chatScriptAos[i].length; q++) {
									if (info.chatScriptAos[i][q].chatContent == '') {
										this.$message.error('私聊用例未填写完整')
										return false
									} else {
										info.chatScriptAos[i][q].chatOrder = q + 1
										info.chatScriptAos[i][q].chatModel = '04'
										chatScriptMap[i] = info.chatScriptAos[i]
									}
								}
							} else {
								this.$message.error('私聊用例未填写完整')
								return false
							}
						}
					} else {
						this.$message.error('私聊用例未填写完整')
						return false
					}
				};
				let activityCasesAos = []
				if (info.scenarioType == "02" || info.scenarioType == '04') {
					console.log(info.activityCasesAos);
					if (info.activityCasesAos.length > 0) {
						for (var a = 0; a < info.activityCasesAos.length; a++) {
							if (info.activityCasesAos[a].activityName == "" || info.activityCasesAos[a].commodityId ==
								'' ||
								info.activityCasesAos[a].commodityPic.length == 0) {
								this.$message.error('活动用例未填写完整')
								return false
							} else {
								activityCasesAos.push({
									"commodityId": info.activityCasesAos[a].commodityId,
									"activityName": info.activityCasesAos[a].activityName,
									"commodityPic": info.activityCasesAos[a].commodityPic[0].url
								})
							}
						}
					} else {
						this.$message.error('活动用例未填写完整')
						return false
					}
				}
				console.log(activityCasesAos);
				console.log(chatScriptMap);
				this.$http.post('/api/plant/positions/insertScenarioDetail', {
					"scenarioType": this.scenarioType, //剧本类型 01: 构建信任02: 拓新吸粉03: 产品种草04: 私聊话术
					"parentId": this.$route.query.id, //剧本ID
					"tacticsType": info.tacticsType, //策略类型ID
					"dayNumber": info.dayNumber, //剧本天数
					"tacticsDescription": info.tacticsDescription, //策略描述
					"targetTask": info.targetTask, //目标任务(条/天)
					"targetDescription": info.targetDescription, //目标任务描述
					"scenario": info.scenario, //情景动作ID
					"sceneDescription": info.sceneDescription, //情景动作描述
					"circleIds": circleIds, //圈文作品ID集合
					//活动用例集合
					"activityCasesAos": activityCasesAos,
					//聊天话术集合
					"chatScriptMap": chatScriptMap,
					"createPerson": this.$store.state.userInfo.id //创建人ID
				}).then(res => {
					console.log(res.data);
					if (res.data.status == 0) {
						this.$message.success(res.data.data)
						this.getInfo()
						this.isShow = true
					} else {
						this.$message.error(res.data.msg)
					}
				})
			},
			//添加01 02 03 04的集合
			addCircleIds(index) {
				this.indexs = index
				console.log(this.infoList[index]);
				if (this.infoList[index].scenarioType == '01' || this.infoList[index].scenarioType == '03') {
					this.dialogVisible = true
					this.tableData = []
				}
				if (this.infoList[index].scenarioType == '02' || this.infoList[index].scenarioType == '04') {
					this.infoList[index].activityCasesAos.push({
						commodityId: "", //商品ID
						activityPath: "", //活动路径
						activityName: "", //活动名称
						commodityPic: [] //商品图片/活动图片 路径
					})
				}
			},
			//添加聊天话术集合
			addCircleIds2(index) {
				let chatScriptAos = this.infoList[index].chatScriptAos
				console.log(chatScriptAos);
				if (chatScriptAos.length > 1) {
					chatScriptAos.forEach(item => {
						if (item.length == 0) {
							this.$message.error('请填写完整再添加')
							return false
						}
						item.forEach(item2 => {
							if (item2.chatContent == '') {
								this.$message.error('请填写完整再添加')
								return false
							}
						})
					})
				} else {
					chatScriptAos.push([])
				}
			},
			//删除01 02 03 04的集合
			del(index, item) {
				if (this.scenarioType == "01" || this.scenarioType == "03") {
					this.infoList[this.indexs].circleIds.splice(index, 1)
				}
				if (this.scenarioType == "02" || this.scenarioType == "04") {
					this.infoList[this.indexs].activityCasesAos.splice(index, 1)
				}
			},
			//删除聊天话术集合
			del2(index, index2) {
				this.infoList[index].chatScriptAos.splice(index2, 1)
			},
			//编辑
			editor(index) {
				this.indexs = index
				this.infoList[index].disable = !this.infoList[index].disable
				let info = this.infoList[index]
				if (info.disable) {
					if (info.tacticsType == '' || info.tacticsDescription == '' || info.dayNumber == '' || info
						.targetDescription == '' || info.scenario == '' ||
						info.sceneDescription == '') {
						this.$message.error('剧本详情未填写完整')
						this.infoList[index].disable = false
						return false
					}
					let circleIds = []
					console.log(info.scenarioType);
					if (info.scenarioType == '01' || info.scenarioType == '03') {
						if (info.circleIds.length > 0) {
							info.circleIds.forEach(i => {
								circleIds.push(i.id)
							})
						} else {
							this.$message.error('活动用例未选择')
							this.infoList[index].disable = false
							return false
						}
					}
					let activityCasesAos = []
					if (info.scenarioType == "02" || info.scenarioType == "04") {
						console.log(info.activityCasesAos);
						if (info.activityCasesAos.length > 0) {
							for (var b = 0; b < info.activityCasesAos.length; b++) {
								if (info.activityCasesAos[b].activityName == "" || info.activityCasesAos[b].commodityId ==
									'' ||
									info.activityCasesAos[b].commodityPic.length == 0) {
									this.$message.error('活动用例未填写完整')
									return false
								} else {
									activityCasesAos.push({
										"id": info.activityCasesAos[b].id,
										"commodityId": info.activityCasesAos[b].commodityId,
										"activityName": info.activityCasesAos[b].activityName,
										"commodityPic": info.activityCasesAos[b].commodityPic[0].url
									})
								}
							}
						} else {
							this.$message.error('活动用例未填写完整')
							this.infoList[index].disable = false
							return false
						}
					}
					let chatScriptMap = {}
					if (info.scenarioType == '04') {
						if (info.chatScriptAos.length > 0) {
							console.log(info.chatScriptAos);
							for (var i = 0; i < info.chatScriptAos.length; i++) {
								if (info.chatScriptAos[i].length > 0) {
									for (var q = 0; q < info.chatScriptAos[i].length; q++) {
										if (info.chatScriptAos[i][q].chatContent == '') {
											this.$message.error('私聊用例未填写完整')
											return false
										} else {
											delete info.chatScriptAos[i][q].createTime
											delete info.chatScriptAos[i][q].kinds
											delete info.chatScriptAos[i][q].updateTime
											delete info.chatScriptAos[i][q].deleteStatus
											delete info.chatScriptAos[i][q].parentId
											info.chatScriptAos[i][q].chatOrder = q + 1
											info.chatScriptAos[i][q].chatModel = '04'
											chatScriptMap[i] = info.chatScriptAos[i]
										}
									}
								} else {
									this.$message.error('私聊用例未填写完整')
									return false
								}
							}
						} else {
							this.$message.error('私聊用例未填写完整')
							return false
						}
					}
					console.log(chatScriptMap);
					this.$http.post('/api/plant/positions/updateScenarioDetail', {
							"id": info.id,
							"scenarioType": this.scenarioType, //剧本类型 01: 构建信任02: 拓新吸粉03: 产品种草04: 私聊话术
							"tacticsType": info.tacticsType, //策略类型ID
							"dayNumber": info.dayNumber, //剧本天数
							"tacticsDescription": info.tacticsDescription, //策略描述
							"targetTask": info.targetTask, //目标任务(条/天)
							"targetDescription": info.targetDescription, //目标任务描述
							"scenario": info.scenario, //情景动作ID
							"sceneDescription": info.sceneDescription, //情景动作描述
							"circleIds": circleIds, //圈文作品ID集合
							"deleteStatus": 0,
							//活动用例集合
							"activityCasesAos": activityCasesAos,
							//聊天话术集合
							"chatScriptMap": chatScriptMap,
							"createPerson": this.$store.state.userInfo.id //创建人ID
						}).then(res => {
							console.log(res);
							if (res.data.status == 0) {
								this.$message.success(res.data.data)
								this.getInfo()
							} else {
								this.$message.error(res.data.msg)
								this.infoList[index].disable = false
							}
						})
						.catch((error) => {
							console.log(error);
							this.$message.error(error);
						})
				}
			},
			addInfoList() {
				this.infoList.push({
					id: '',
					scenarioType: this.$route.query.scenarioType, //剧本类型01:构建信任02:拓新吸粉03:产品种草04:私聊话术
					parentId: this.$route.query.id, //剧本ID
					tacticsType: "", //策略类型ID
					dayNumber: this.infoList.length + 1, //剧本天数
					tacticsDescription: "", //策略描述
					targetTask: "", //目标任务(条/天)
					targetDescription: "", //目标任务描述
					scenario: "", //情景动作ID
					sceneDescription: "", //情景动作描述
					circleIds: [], //圈文作品ID集合
					//活动用例集合
					activityCasesAos: [],
					//聊天话术集合
					chatScriptAos: [],
					disable: false,
				})
				this.isShow = false
				console.log(this.infoList);
			},
			//删除剧本的某一天
			delInfoList(item, index) {
				let circleIds = []
				if (item.circleIds.length > 0) {
					item.circleIds.forEach(i => {
						circleIds.push(i.id)
					})
				}
				this.$confirm('此操作将永久删除剧本, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$http.post('/api/plant/positions/updateScenarioDetail', {
						"id": item.id,
						"deleteStatus": 1,
						"scenarioType": this.scenarioType, //剧本类型 01: 构建信任02: 拓新吸粉03: 产品种草04: 私聊话术
						// "parentId": this.$route.query.id, //剧本ID
						"tacticsType": item.tacticsType, //策略类型ID
						"dayNumber": item.dayNumber, //剧本天数
						"tacticsDescription": item.tacticsDescription, //策略描述
						"targetTask": item.targetTask, //目标任务(条/天)
						"targetDescription": item.targetDescription, //目标任务描述
						"scenario": item.scenario, //情景动作ID
						"sceneDescription": item.sceneDescription, //情景动作描述
						"circleIds": circleIds, //圈文作品ID集合
						//活动用例集合
						"activityCasesAos": [],
						//聊天话术集合
						"chatScriptAos": [],
						"createPerson": this.$store.state.userInfo.id //创建人ID
					}).then(res => {
						if (res.data.status == 0) {
							this.$message({
								type: 'success',
								message: '删除成功!'
							});
							this.getInfo()
							console.log(this.infoList);
							this.isShow = true
						}
					})
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除'
					});
				});
			},
			//选择圈文
			choose(row) {
				let img = []
				let img2 = []
				// img2 = row.matImg.split(',')
				// if (img2.length > 0) {
				// 	img2.forEach(i => {
				// 		img.push({
				// 			url: i[0]
				// 		})
				// 	})
				// }
				this.infoList[this.indexs].circleIds.push({
					id: row.matId,
					matInfo: row.matInfo,
					img: row.matImg2
				})
				this.dialogVisible = false
			},
			//查询圈文
			Query() {
				this.getList()
			},
			//页面的条数发生改变时
			handleSizeChange(size) {
				this.pageSize = size
				//重新请求数据
				this.getList()
			},
			//当前页发生改变时
			handleCurrentChange(currentPage) {
				this.pageNum = currentPage
				//重新请求数据
				this.getList()
			},
			zhikong() {
				this.query = {
					arr: [],
					id2: '',
					matPersona: '',
					title4: '',
				}
				this.getList()
			},
			//圈文素材
			getList() {
				let categoryId = ''
				if (this.query.arr.length > 0) {
					categoryId = this.query.arr[1]
				}
				this.$http.post('/api/plant/groupMaterial/selectMaterial', {
					categoryId: categoryId,
					labelId: this.query.matPersona,
					matStyle: this.query.id2,
					matInfo: this.query.title4,
					pageNum: this.pageNum,
					pageSize: this.pageSize
				}).then(res => {
					this.total = res.data.data.total
					if (res.data.data.list.length > 0) {
						res.data.data.list.forEach(item => {
							item.matImg2 = item.matImg.split(',')[0]
						})
					}
					this.tableData = res.data.data.list
				})
			},
			//获取明细
			getInfo() {
				this.$http.post('/api/plant/positions/selectScenarioDetail', {
					"ids": [this.$route.query.id],
				}).then(res => {
					console.log('明细', res.data.data);
					if (res.data.data.length > 0) {
						this.infoList = []
						res.data.data.forEach(i => {
							i.circleIds = []
							i.activityCasesAos = []
							if (i.groupMaterialVos) {
								i.groupMaterialVos.forEach(item => {
									item.matImg = item.matImg.split(',')
									i.circleIds.push({
										id: item.matId,
										img: item.matImg[0],
										matInfo: item.matInfo
									})
								})
							}
							if (i.festivalCommodityVos) {
								i.festivalCommodityVos.forEach(item => {
									i.activityCasesAos.push({
										id: item.id,
										commodityId: item.commodityId, //商品ID
										activityPath: item.activityPath, //活动路径
										activityName: item.activityName, //活动名称
										commodityPic: [{
											url: item.commodityPic
										}]
									})
								})
							}
							var a = i.chatScriptVos;
							// console.log(a);
							var b = [];
							if (a) {
								a.forEach((item) => {
									b.push(item.chatRecords);
								});
							}
							// console.log(b);
							var c = Array.from(new Set(b));
							// console.log(c);
							var e = [];
							if (c.length > 0) {
								c.forEach((item, index) => {
									var d = [];
									d = a.filter((ele) => ele.chatRecords == item);
									if (d.length > 1) {
										e.push(d);
									}
								});
							}
							let chatScriptVos = e
							this.infoList.push({
								cz: true,
								id: i.id,
								scenarioType: i.scenarioType,
								tacticsType: i.tacticsType, //策略类型ID
								dayNumber: i.dayNumber, //剧本天数
								tacticsDescription: i.tacticsDescription, //策略描述
								targetTask: i.targetTask, //目标任务(条/天)
								targetDescription: i.targetDescription, //目标任务描述
								scenario: i.scenario, //情景动作ID
								sceneDescription: i.sceneDescription, //情景动作描述
								circleIds: i.circleIds, //圈文作品ID集合
								activityCasesAos: i.activityCasesAos, //活动用例集合
								chatScriptAos: chatScriptVos, //聊天话术集合
								disable: true
							})
							console.log(this.infoList);
						})
					} else {
						this.infoList = []
					}
				})
			},
			//获取分类
			getpaiCategory() {
				this.$http.get("/api/product/productCategory/paiCategory?pageSize=999&pageNum=1&paiStatus=1", {})
					.then((
						res) => {
						// console.log('分类', res.data.data.list);
						this.options = res.data.data.list;
					});
			},
			//获取销售人群
			getinfo2() {
				this.$http.post("/api/plant/clrLabel/selectLabel", {
					"type": 4,
					"useStatus": 0
				}).then((res) => {
					res.data.data.forEach((item) => {
						this.options2.push({
							id: item.memberLabelId,
							name: item.name,
						})
					})
				});
			},
			//获取策略
			getInfo3(parentId) {
				this.$http.get(`/api/setting/paiBoCategory/PaiBoCategoryDropDown?parentId=${parentId}`, {}).then(res => {
					console.log("策略", res.data.data);
					if (res.data.data.length > 0) {
						res.data.data.forEach(i => {
							this.options3.push({
								label: i.dicDesc,
								value: i.dicId
							})
						})
					}
				})
			},
			//获取动作
			getInfo4(parentId) {
				this.$http.get(`/api/setting/paiBoCategory/PaiBoCategoryDropDown?parentId=${parentId}`, {}).then(res => {
					console.log("动作", res.data.data);
					if (res.data.data.length > 0) {
						res.data.data.forEach(i => {
							this.options4.push({
								label: i.dicDesc,
								value: i.dicId
							})
						})
					}
				})
			},
			//获取圈文类型
			getInfo5() {
				this.$http.get(`/api/setting/paiBoCategory/PaiBoCategoryDropDown?dicModular=22`, {}).then(res => {
					// console.log("圈文类型", res.data.data);
					if (res.data.data.length > 0) {
						res.data.data.forEach(i => {
							this.options5.push({
								label: i.dicDesc,
								value: i.dicId
							})
						})
					}
				})
			},
		},
		created() {
			this.getInfo()
			this.getpaiCategory()
			this.getinfo2()
			this.getInfo3(this.$route.query.parentId)
			this.getInfo4(this.$route.query.parentId2)
			this.getInfo5()
		}
	}
</script>

<style scoped="scoped">
	.el-tag+.el-tag {
		margin-left: 10px;
	}
</style>
